import type { ReactNode } from "react";

interface CrossLinkProps {
  href: string;
  children: ReactNode;
  /** Semibold, for a link that stands on its own line rather than in prose. */
  bold?: boolean;
}

/**
 * Inline link from one marketing page to another, set in running copy:
 * ink text with the brand-red underline, so it reads as part of the
 * sentence rather than a button.
 */
export const CrossLink = ({ href, children, bold = false }: CrossLinkProps) => (
  <a
    href={href}
    className={`text-fwd-ink ${bold ? "font-semibold" : "font-medium"} underline decoration-fwd-red decoration-2 underline-offset-4 hover:text-fwd-red transition-colors`}
  >
    {children}
  </a>
);
